module.exports = __webpack_public_path__ + "static/media/ram.ec975bac.svg";